import React, { Component } from 'react';

const withContext = (WrappedComponent, Context) => {
  class CompWithContext extends Component {
    render() {
      const { forwardedRef, ...rest } = this.props;
      return (
        <Context.Consumer>
          {
            data => (
              <WrappedComponent
                {...data}
                {...rest}
                ref={forwardedRef} // eslint-disable-line
              />
            )
          }
        </Context.Consumer>
      );
    }
  }

  return React.forwardRef((props, ref) => <CompWithContext {...props} forwardedRef={ref} />);
};

export default withContext;
